// services/storageMigration.js - Service de migration des données de stockage
import AsyncStorage from '@react-native-async-storage/async-storage';
import AsyncStorageHelper from './asyncStorageHelper';

// Fonction utilitaire pour migrer les anciennes données
export const migrateStorageData = async () => {
  console.log('🔄 Starting storage migration...');
  
  try {
    const keysToMigrate = [
      'authToken',
      'userEmail', 
      'sheetId',
      'competitions',
      'refreshInterval',
      'hapticType',
      'hapticEnabled',
      'lastSelectedSection',
      'navigationTransition',
      'pwaInstallDismissed'
    ];
    
    let migratedCount = 0;
    
    for (const key of keysToMigrate) {
      try {
        // Essayer de lire avec l'ancienne méthode directe
        const oldValue = await AsyncStorage.getItem(key);
        
        if (oldValue !== null) {
          console.log(`🔍 Found data for ${key}:`, typeof oldValue, oldValue?.substring(0, 50));
          
          // Tenter de parser si c'est du JSON, sinon garder la string
          let parsedValue;
          try {
            // Si ça commence par { ou [ ou c'est true/false, c'est probablement du JSON
            if (oldValue.startsWith('{') || oldValue.startsWith('[') || 
                oldValue === 'true' || oldValue === 'false') {
              parsedValue = JSON.parse(oldValue);
            } else {
              parsedValue = oldValue; // C'est déjà une string simple
            }
          } catch (parseError) {
            console.log(`📝 ${key} is a simple string, keeping as-is`);
            parsedValue = oldValue;
          }
          
          // Sauvegarder avec la nouvelle méthode sécurisée
          const success = await AsyncStorageHelper.setItem(key, parsedValue);
          if (success) {
            console.log(`✅ Migrated ${key} successfully`);
            migratedCount++;
          } else {
            console.warn(`⚠️ Failed to migrate ${key}`);
          }
        } else {
          console.log(`ℹ️ No data found for ${key}`);
        }
      } catch (error) {
        console.error(`❌ Error migrating ${key}:`, error);
        
        // En cas d'erreur, essayer de nettoyer la clé corrompue
        try {
          await AsyncStorage.removeItem(key);
          console.log(`🧹 Removed corrupted key: ${key}`);
        } catch (removeError) {
          console.error(`Failed to remove corrupted key ${key}:`, removeError);
        }
      }
    }
    
    console.log(`🔄 Storage migration completed: ${migratedCount} keys migrated`);
    
    // Marquer la migration comme terminée
    await AsyncStorageHelper.setItem('migrationCompleted', true);
    
    return true;
  } catch (error) {
    console.error('❌ Storage migration failed:', error);
    return false;
  }
};

// Vérifier si la migration a déjà été effectuée
export const checkMigrationStatus = async () => {
  try {
    const migrationCompleted = await AsyncStorageHelper.getItem('migrationCompleted', false);
    return migrationCompleted === true;
  } catch (error) {
    console.error('Error checking migration status:', error);
    return false;
  }
};

// Force une nouvelle migration (utile pour le debugging)
export const forceMigration = async () => {
  try {
    await AsyncStorageHelper.removeItem('migrationCompleted');
    return await migrateStorageData();
  } catch (error) {
    console.error('Force migration failed:', error);
    return false;
  }
};

export default {
  migrateStorageData,
  checkMigrationStatus,
  forceMigration
};